import React from "react";

const MechanicCard = ({ mechanic }) => {
  return (
    <div className="bg-white rounded-lg shadow-lg p-4 border border-gray-200">
      <h3 className="text-xl font-bold text-gray-900">{mechanic.name}</h3>
      <p className="text-gray-700">📍 {mechanic.location}</p>
      <p className="text-gray-700">📞 {mechanic.phoneNumber}</p>
      <p className="text-gray-700">⭐ {mechanic.rating} / 5</p>
      <p className="text-gray-700">🛠️ Specialties: {mechanic.specialties.join(", ")}</p>
    </div>
  );
};

export default MechanicCard;